import { render, staticRenderFns } from "./IconTitleText.vue?vue&type=template&id=1db20bd3&"
import script from "./IconTitleText.vue?vue&type=script&lang=js&"
export * from "./IconTitleText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports